import React, {useState} from "react";

import {useTranslation} from "react-i18next";
import {queries} from "shared/api/queries";
import client from "api/client";
import {DraggableModal} from "shared/ui/modal/draggableModal";
import {IPlanLongItem, IPlanShortItem} from "features/plan/types";
import {useModal, useToast} from "shared/ui";
import {getApiErrorMsg} from "shared/lib/fns";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";
import {PlanList} from "features/plan/components/modal/PlanList";

interface Props {
  onMerged: () => void;
  onHide: () => void;
  srcPlan: IPlanLongItem;
}

export const MergePlanPopup = ({
                                 onMerged, onHide, srcPlan
                               }: Props) => {
  const {t} = useTranslation("shipping");
  const toast = useToast();
  const modal = useModal();
  const [selectedPlan, setSelectedPlan] = useState<IPlanShortItem>();
  const [isLoading, setIsLoading] = useState(false);
  
  const handleMerge = () => {
    if (!!selectedPlan) {
      if (selectedPlan.merge_allowed) {
        modal.warning({title: "", children: t("Please, select a plan not sorted")});
      }
      else {
        setIsLoading(true);
        client
        .post(queries.plan.merge(selectedPlan.id), {src_plan_id: srcPlan.id})
        .then(onMerged)
        .catch((e) => {
          toast.error(getApiErrorMsg(e));
        })
        .finally(() => {
          setIsLoading(false);
        });
      }
      onHide();
    }
    else {
      modal.info({title: "", children: t("Please, select plan to be merged")});
    }
  };
  
  return (<DraggableModal
    width={335}
    onClose={onHide}
    confirmText={t("merge plan")}
    cancelText={t("popup.btn.back")}
    title={t("merge plan")}
    showCancel
    onConfirm={handleMerge}
  >
    <PlanList onSelectPlan={setSelectedPlan} srcPlan={srcPlan} selectedPlan={selectedPlan} />
    {isLoading && (<LoadingSpinner className={"spinner"} />)}
  </DraggableModal>);
};
